// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.85);
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-modal .container {
    background-color: white;
    box-sizing: border-box!important;
    box-shadow: 14px 14px 14px rgba(0, 0, 0, 0.25)!important;
    border-radius: 10px!important;
    position: relative;
}

.container .delete-msg {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: x-large;
}
/* .custom-modal .content-container {
    width: 100%;
    height: 100%;
} */

.custom-modal .submit-msg {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: x-large;
}

.custom-modal .icon:hover {
    cursor: pointer!important;
}

.custom-modal .title {
    display: flex!important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.custom-modal .title .error {
    color: red;
    font-size: large;
    text-align: center;
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-modal .title .icon{
    background: #E5E5E5;
    border-radius: 17px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px;
}

.custom-modal .title .text{
    display: flex!important;
    justify-content: center;
    align-items: center;
    font-size: large;
}

.custom-modal .title span{
    padding: 0% 1%;
}

.custom-modal .actions-bar {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.custom-modal .actions-bar .buttons-div{
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.custom-modal .actions-bar .buttons-div-edited{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

/* .custom-modal .actions-bar button {
    opacity: 0.62;
    border-radius: 8px;
    color: white;
    display: flex;
    background: var(--link-active);
    border: none;
    align-items: center;
    padding: 1%;
    width: 15%;
    justify-content: center;
    font-weight: 600;
}

.custom-modal .actions-bar button:hover {
    cursor: pointer;
} */
`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,wDAAwD;IACxD,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;;GAGG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;;;;;;;;;;;;;;;;GAgBG","sourcesContent":[".custom-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,.85);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-modal .container {\n    background-color: white;\n    box-sizing: border-box!important;\n    box-shadow: 14px 14px 14px rgba(0, 0, 0, 0.25)!important;\n    border-radius: 10px!important;\n    position: relative;\n}\n\n.container .delete-msg {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    font-size: x-large;\n}\n/* .custom-modal .content-container {\n    width: 100%;\n    height: 100%;\n} */\n\n.custom-modal .submit-msg {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: x-large;\n}\n\n.custom-modal .icon:hover {\n    cursor: pointer!important;\n}\n\n.custom-modal .title {\n    display: flex!important;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.custom-modal .title .error {\n    color: red;\n    font-size: large;\n    text-align: center;\n    width: 40%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-modal .title .icon{\n    background: #E5E5E5;\n    border-radius: 17px;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 5px;\n}\n\n.custom-modal .title .text{\n    display: flex!important;\n    justify-content: center;\n    align-items: center;\n    font-size: large;\n}\n\n.custom-modal .title span{\n    padding: 0% 1%;\n}\n\n.custom-modal .actions-bar {\n    position: absolute;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 10px;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.custom-modal .actions-bar .buttons-div{\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.custom-modal .actions-bar .buttons-div-edited{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n}\n\n/* .custom-modal .actions-bar button {\n    opacity: 0.62;\n    border-radius: 8px;\n    color: white;\n    display: flex;\n    background: var(--link-active);\n    border: none;\n    align-items: center;\n    padding: 1%;\n    width: 15%;\n    justify-content: center;\n    font-weight: 600;\n}\n\n.custom-modal .actions-bar button:hover {\n    cursor: pointer;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
